(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('AccessDetailController', AccessDetailController);

    AccessDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Access', 'Patient'];

    function AccessDetailController($scope, $rootScope, $stateParams, previousState, entity, Access, Patient) {
        var vm = this;

        vm.access = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:accessUpdate', function(event, result) {
            vm.access = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
